import React, {useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {addInternationalTeam} from "../../actions/International";
import {addInsight} from "../../actions/NewsPages";

interface FormData {
    name: string;
    title: string;
    image: File | null;
    email: string;
    regions: string | null;
}

function AddInternationalTeam() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const user = location.state?.user;

    const [formData, setFormData] = useState<FormData>({
        name: "",
        title: "",
        image: null,
        email: "",
        regions: ""
    });

    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const navigate = useNavigate();

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0] || null;

            setFormData(prev => ({ ...prev, image: file }));

            if (file) {
                const previewUrl = URL.createObjectURL(file);
                setImagePreview(previewUrl);
            } else {
                setImagePreview(null);
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const formDataToSend = new FormData();

            // Append basic form data
            Object.keys(formData).forEach(key => {
                const value = formData[key as keyof FormData];
                if (value !== null && value !== undefined) {
                    if (value instanceof File) {
                        formDataToSend.append(key, value);
                    } else {
                        formDataToSend.append(key, value.toString());
                    }
                }
            });

            // Call the actual API method
            const response = await addInternationalTeam(formDataToSend);

            if (response.status === 201) {
                alert("Successfully added new international team member!");
                // Wrap navigate in setTimeout to ensure it runs after alert
                setTimeout(() => {
                    navigate('/dashboard/international/team/list', { state: { user } });
                }, 0);
            } else {
                alert(response.data?.message || "An unexpected error occurred");
            }

        } catch (error: any) {
            console.error("Error submitting form:", error);
            // If the server returned validation errors:
            if (error.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors).flat();
                console.log(errorMessages);
            } else {
                alert(["An error occurred while submitting the form"]);
            }
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>

                <form
                    className="form-horizontal form-label-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"
                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                >
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Name"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Title"
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Regions"
                            id="regions"
                            name="regions"
                            value={formData.regions ?? ""}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group" style={{ marginBottom: '10px' }}>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label className="control-label" style={{ marginRight: '20px' }}>Image</label>
                            <br/>

                            <input
                                type="file"
                                id="image_1"
                                className="form-control news_image"
                                name="image"
                                ref={fileInputRef}
                                onChange={handleInputChange}
                            />

                            {/* ✅ PREVIEW DISPLAY */}
                            {imagePreview && (
                                <div style={{ marginTop: "10px" }}>
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{ maxWidth: "300px", maxHeight: "300px" }}
                                    />
                                </div>
                            )}

                            <br/>
                        </div>
                    </div>

                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Email Address"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group" style={{ marginBottom: '0' }}>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <button type="submit" className="btn btn-success">
                                Submit
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    )
}

export default AddInternationalTeam;
